var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center min-vh-100"})
}
var staticRenderFns = []

export { render, staticRenderFns }